// extracted by mini-css-extract-plugin
export default {"preview":"ePMzN","landscape":"GufLf","portrait":"ABrqZ","content":"WoPnI","tooltip":"zO4pn","image":"ir59z"};